var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Earnings, gifts, etc... probably just one div per gift/user so its a big ole long cvs receipt of people who gifted you ")])
}
var staticRenderFns = []

export { render, staticRenderFns }